import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Notes from './pages/Notes';
import ProjectDetail from './pages/ProjectDetail';
import Projects from './pages/Projects';
import TargetCursor from './components/TargetCursor';
import GradualBlur from './components/GradualBlur';
import PageLoader from './components/PageLoader';
import { ContentService } from './services/content';
import { Project } from './types';
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
// Global scroll blur controller to ensure navigation is clear at the bottom
const GlobalScrollEffects = () => {
  const [isAtBottom, setIsAtBottom] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollY + windowHeight >= documentHeight - 150) {
        setIsAtBottom(true);
      } else {
        setIsAtBottom(false);
      }
    };
    setIsAtBottom(false);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);
  return <>
      {/* Bottom blur that disappears when footer is in view */}
      <GradualBlur target="page" position="bottom" height="12rem" strength={3} divCount={8} curve="bezier" exponential opacity={isAtBottom ? 0 : 1} zIndex={35} style={{
      transition: 'opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
    }} data-id="element-0" />
    </>;
};
const RouteChangeLoader = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState(0);
  useEffect(() => {
    setLoading(true);
    setKey(k => k + 1);
    const timer = setTimeout(() => setLoading(false), 1100);
    return () => clearTimeout(timer);
  }, [location.pathname]);
  if (!loading) return null;
  return <PageLoader key={key} data-id="element-1" />;
};
const App: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const loadContent = async () => {
      setIsLoading(true);
      try {
        const data = await ContentService.getAllProjects();
        setProjects(data);
      } catch (error) {
        console.error('Failed to fetch projects:', error);
      } finally {
        setIsLoading(false);
      }
    };
    loadContent();
  }, []);
  return <Router data-id="element-2">
      <TargetCursor spinDuration={4} hideDefaultCursor={true} parallaxOn={true} hoverDuration={0.3} data-id="element-3" />
      <ScrollToTop data-id="element-4" />
      <GlobalScrollEffects data-id="element-5" />
      <RouteChangeLoader data-id="element-6" />

      <div className="min-h-screen flex flex-col bg-black text-white selection:bg-white selection:text-black overflow-x-hidden" data-id="element-7">
        <Navbar data-id="element-8" />
        {/* main container with relative z-50 to ensure it is always above background layers */}
        <main className="flex-grow relative z-[50]" data-id="element-9">
          <Routes data-id="element-10">
            <Route path="/" element={<Home projects={projects} isLoading={isLoading} data-id="element-12" />} data-id="element-11" />
            <Route path="/about" element={<About data-id="element-14" />} data-id="element-13" />
            <Route path="/projects" element={<Projects projects={projects} isLoading={isLoading} data-id="element-16" />} data-id="element-15" />
            <Route path="/projects/:slug" element={<ProjectDetail data-id="element-18" />} data-id="element-17" />
            <Route path="/notes" element={<Notes data-id="element-20" />} data-id="element-19" />
            <Route path="/contact" element={<Contact data-id="element-22" />} data-id="element-21" />
          </Routes>
        </main>
        <Footer count={projects.length} data-id="element-23" />
      </div>
    </Router>;
};
export { App };